/**
 * Помощна фунция за визуализация на текст.
 * Има възможност текстовете в JSX-a да се зареждат от външен JSON файл.
 * В този файл, случай на нужда, могат да се редактират от трети лица.
 *
 * JSON файла е key->value JS обект
 *
 * Пример:
 * _t("Здравейте")
 * _t("Здравейте :firstName",{firstName:'Иван'});
 * _t("Здравейте :firstName :lastName",{firstName:'Иван',lastName:'Иванов'});

 *
 * @param message ключа на съобщението (което може да е самото съобщение)
 * @param param JSON обект с параметри, които могат да се подават в случай на нужда
 */
import React from 'react';

export function __t(message, param = null, allowHtml = false) {
	let msg = message;

	if (window["shTextResource"]) {
		if (window["shTextResource"][message]) {
			msg = window["shTextResource"][message];
		}
	}
	if (param) {
		Object.keys(param).forEach((key) => {
			msg = msg.replaceAll(':' + key, param[key]);
		});
	}

	if (allowHtml === true) {
		return React.createElement('span', {
			dangerouslySetInnerHTML: {__html: msg},
		});
	} else {
		return msg;
	}
}